(function() {
  var STORAGE_KEY = 'jc-favorites';

  function getFavorites() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch(e) {
      return [];
    }
  }

  function saveFavorites(favs) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favs));
  }

  function isFavorite(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var favs = getFavorites();
    var idx = favs.indexOf(handle);
    if (idx === -1) {
      favs.push(handle);
    } else {
      favs.splice(idx, 1);
    }
    saveFavorites(favs);
    updateUI();
    return favs.indexOf(handle) !== -1;
  }

  function updateUI() {
    var favs = getFavorites();

    var stars = document.querySelectorAll('[data-fav-star]');
    stars.forEach(function(btn) {
      var handle = btn.getAttribute('data-fav-star');
      var active = favs.indexOf(handle) !== -1;
      btn.classList.toggle('fav-star--active', active);
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.fill = active ? '#c8a96e' : 'none';
        svg.style.stroke = active ? '#c8a96e' : '#1a1a1a';
      }
    });

    var items = document.querySelectorAll('[data-fav-item]');
    items.forEach(function(el) {
      var handle = el.getAttribute('data-fav-item');
      el.classList.toggle('folder-item--fav', favs.indexOf(handle) !== -1);
    });

    var counter = document.getElementById('fav-count');
    if (counter) {
      counter.textContent = favs.length;
      counter.style.display = favs.length > 0 ? 'flex' : 'none';
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fav-star]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-fav-star');
      toggleFavorite(handle);
    }
  });

  document.addEventListener('DOMContentLoaded', updateUI);

  window.JCFavorites = {
    get: getFavorites,
    isFavorite: isFavorite,
    toggle: toggleFavorite,
    update: updateUI
  };
})();
